import { RouteConfig } from "vue-router";

export const my: RouteConfig[] = [
  {
    // マイページ
    path: "my",
    name: "my-details",
    component: () => import("@/pages/My/MyDetails.vue")
  }
];
